import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, HelpCircle } from 'lucide-react';
const forYouItems = ['Your A1C is between 5.7 and 6.9 despite eating clean', "You are 50+ and frustrated that willpower isn't enough", 'You want a system, not another list of foods to avoid', 'You are willing to walk 15 minutes after meals', 'You want to understand WHY your body responds the way it does'];
const notForYouItems = ['You are looking for a magic pill with zero effort', 'You refuse to track or measure anything', 'You want a generic meal plan with no science behind it', 'You are not willing to change your meal timing'];
export function WhoIsThisFor() {
  return <section className="w-full py-24 px-4 bg-[#111111] border-t border-gray-800" data-id="element-233">
      <div className="max-w-6xl mx-auto" data-id="element-234">
        <div className="text-center mb-16 space-y-4" data-id="element-235">
          <div className="flex items-center justify-center gap-2 text-accent mb-4" data-id="element-236">
            <HelpCircle className="w-6 h-6" data-id="element-237" />
            <span className="font-bold tracking-widest uppercase" data-id="element-238">
              Qualification Check
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-wide" data-id="element-239">
            Is This Protocol Right For You?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-240">
          {/* For You Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gray-900/30 border border-green-900/30 rounded-xl p-8 relative overflow-hidden" data-id="element-241">
            <div className="absolute top-0 left-0 w-full h-1 bg-green-500/50" data-id="element-242" />
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-243">
              <span className="text-green-500" data-id="element-244">THIS IS FOR YOU IF:</span>
            </h3>
            <ul className="space-y-6" data-id="element-245">
              {forYouItems.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-246">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-247" />
                  <span className="text-gray-300 text-lg leading-relaxed" data-id="element-248">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-900/30 border border-red-900/30 rounded-xl p-8 relative overflow-hidden" data-id="element-249">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500/50" data-id="element-250" />
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-251">
              <span className="text-red-500" data-id="element-252">THIS IS NOT FOR YOU IF:</span>
            </h3>
            <ul className="space-y-6" data-id="element-253">
              {notForYouItems.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-254">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-255" />
                  <span className="text-gray-400 text-lg leading-relaxed" data-id="element-256">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}